<template>
  <div class="share-buttons">
    <h4 class="text-center">Share</h4>

    <!-- Facebook -->
    <a
      :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url)"
      target="_blank"
      title="Share on Facebook"
      class="share-btn facebook"
    >
      <img src="/Content/images/Optimized/Icons/icon_facebook_social.svg" alt="Facebook">
    </a>

    <!-- Twitter -->
    <a
      :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title)"
      target="_blank"
      title="Share on Twitter"
      class="share-btn twitter"
    >
      <img src="/Content/images/Optimized/Icons/icon_twitter_social_dark.svg" alt="Twitter">
    </a>

    <!-- WhatsApp -->
    <a
      :href="'https://wa.me/?text=' + encodeURIComponent(title + ' - ' + url)"
      target="_blank"
      title="Share on WhatsApp"
      class="share-btn whatsapp"
    >
      <img src="/Content/images/Optimized/Icons/icon_whatsapp_social.svg" alt="WhatsApp">
    </a>

    <!-- Email -->
    <a href="#emailModal" data-toggle="modal" title="Email" class="share-btn email">
      <img src="/Content/images/Optimized/Icons/icon_message_social.svg" alt="Email">
    </a>

    <!-- Email Modal -->
    <div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button>
            <h5>Send Listing to:</h5>
            <form @submit.prevent="sendEmail">
              <div class="form-group">
                <label for="toEmail">To email*</label>
                <input v-model="emailTo" class="form-control" id="toEmail" type="email" required placeholder="Recipient Email">
              </div>
              <div class="form-group">
                <label for="fromEmail">From email*</label>
                <input v-model="emailFrom" class="form-control" id="fromEmail" type="email" required placeholder="Your Email">
              </div>
              <div class="form-group">
                <label for="message">Optional Message</label>
                <textarea v-model="emailMessage" class="form-control" id="message" rows="4" placeholder="Message"></textarea>
              </div>
              <button type="submit" class="btn btn-success">Send</button>
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareButtons',
  props: {
    title: { type: String, required: true },
    url: { type: String, required: true },
    description: { type: String, default: '' }
  },
  data() {
    return {
      emailTo: '',
      emailFrom: '',
      emailMessage: ''
    };
  },
  methods: {
    sendEmail() {
      console.log('Email To:', this.emailTo);
      console.log('Email From:', this.emailFrom);
      console.log('Message:', this.emailMessage);
      $('#emailModal').modal('hide');
      alert('Email sent! (demo)');
    }
  }
};
</script>

<style scoped>
.share-buttons {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.9);
  padding: 10px;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
}
.share-buttons h4 {
  margin-bottom: 5px;
  font-size: 14px;
}
.share-btn img {
  width: 40px;
  height: 40px;
}
</style>
